export const getters = {
  getVenda: (state) => state.venda,
  getVendas: (state) => state.vendas,
  getProdutoVenda: (state) => state.produtoVenda,
  getProdutosVenda: (state) => state.produtosVenda,
  getClienteVenda: (state) => state.clienteVenda,
  getModalExcluirVenda: (state) => state.modalExcluirVenda,
  getModalImprimirVenda: (state) => state.modalImprimirVenda,
  getModalVisualizarVenda: (state) => state.modalVisualizarVenda,
  getDescontoTotalPercentualVenda: (state) => state.descontoTotalPercentualVenda,
  getModalListarVenda: (state) => state.modalListarVenda,
  getTotalVendaComDescontoAdicional: (state) => state.totalVendaComDescontoAdicional,
  getModalDescontoAdicionalVenda: (state) => state.modalDescontoAdicionalVenda,
  getDescontoAdicionalTotalVenda: (state) => state.descontoAdicionalTotalVenda,
  getModalExclusaoVenda: (state) => state.modalExclusaoVenda,
  getCheckListProdutoVenda: (state) => state.checklistProdutoVenda
};

export default {};
